const platforms = [
  { name: 'Windows', icon: 'ri-windows-line', ext: '.exe', size: '28.6 MB', version: 'v2.0.1' },
  { name: 'macOS', icon: 'ri-apple-line', ext: '.dmg', size: '31.2 MB', version: 'v2.0.1' },
  { name: 'iOS', icon: 'ri-smartphone-line', ext: 'App Store', size: '22.8 MB', version: 'v2.0.0' },
  { name: 'Android', icon: 'ri-android-line', ext: '.apk', size: '18.4 MB', version: 'v2.0.1' },
];

export default function DownloadSection() {
  return (
    <section id="download" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
            立即下载<span className="text-primary-500">娜娜轻量版</span>
          </h2>
          <p className="mt-4 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            选择你的平台，开启轻盈高效的全新体验。所有版本核心功能免费使用。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {platforms.map((platform) => (
            <div
              key={platform.name}
              className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-300/60 transition-colors duration-200 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${platform.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">{platform.name}</h3>
              <p className="text-sm text-foreground-600 mb-1">{platform.size} · {platform.version}</p>
              <p className="text-xs text-foreground-500 mb-5">{platform.ext}</p>
              <button className="w-full py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                下载
                <i className="ri-download-line ml-1.5"></i>
              </button>
            </div>
          ))}
        </div>

        <p className="text-center mt-8 text-xs text-foreground-500">
          系统要求：Windows 10+ / macOS 12+ / iOS 15+ / Android 10+
        </p>
      </div>
    </section>
  );
}